import { useState } from 'react'

import { cn } from '@/lib/utils'

function getInitials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean)
  if (parts.length === 0) return '?'
  if (parts.length === 1) return parts[0]!.charAt(0).toUpperCase()
  return (
    parts[0]!.charAt(0) + parts[parts.length - 1]!.charAt(0)
  ).toUpperCase()
}

function Avatar({
  name,
  src,
  className,
}: {
  name: string
  src?: string
  className?: string
}) {
  const [errored, setErrored] = useState(false)
  const showImage = src && !errored

  return (
    <span
      data-slot="avatar"
      aria-label={name}
      // Foreground/ring are semantic, not brand — brand tint stays constant
      // across modes, so text-primary would be Marco Blue on near-black in dark.
      className={cn(
        'bg-primary/15 text-foreground ring-foreground/20 inline-flex size-7 shrink-0 items-center justify-center overflow-hidden rounded-full text-[0.625rem] font-medium ring-1 select-none',
        className,
      )}
    >
      {showImage ? (
        <img
          src={src}
          alt={name}
          className="size-full object-cover"
          onError={() => setErrored(true)}
        />
      ) : (
        getInitials(name)
      )}
    </span>
  )
}

export { Avatar }
